import { NavLink } from 'react-router-dom';
import { styled } from '@mui/material';
import { StyledSidebarItem } from './sidebar-section-base-item';
import { SidebarItem } from './common-sidebar-section.types';
import { sidebarSectionClickableStyles } from './common-sidebar-section';

export const SidebarSectionLink = ({
  notificationCount,
  path,
  isSidebarOpen,
  ...props
}: SidebarItem) => {
  return (
    <StyledSidebarLink
      style={({ isActive }) => (isActive ? { pointerEvents: 'none' } : {})}
      to={path}
      key={path}
    >
      {({ isActive }) => (
        <StyledSidebarItem
          isActive={isActive}
          icon={props.icon}
          label={props.label}
          notificationCount={notificationCount}
          isSidebarOpen={isSidebarOpen}
        />
      )}
    </StyledSidebarLink>
  );
};

export const StyledSidebarLink = styled(NavLink)(({ theme }) =>
  sidebarSectionClickableStyles(theme)
);
